// web_components/wcSpotlightPromo/wcSpotlightPromo_Renderer.ts

/**
 * Generates the HTML for the wc-spotlight-promo component.
 * Handles CSS, variables, etc.
 *
 * @param {object} dataAttributes - Data attributes for styling and contextual information.
 * @param {string} instanceId - A unique instance ID for generating unique element IDs.
 * @returns {string} - The HTML string for the content component.
 */
export function renderProductHTML(dataAttributes: any, instanceId: string): string {
	// Initialize styleTag to an empty string
	let styleTag = '';

	// Check if 'css' exists in dataAttributes and is an object
	if (dataAttributes.css && typeof dataAttributes.css === 'object') {
		styleTag = `<style>`;
		for (const [selector, styles] of Object.entries(dataAttributes.css)) {
			styleTag += `${selector} { ${styles} }`;
		}
		styleTag += `</style>`;
	}

	// Access variables and assign to 'variables', defaulting to an empty object if undefined
	const variables = dataAttributes.variables || {};

	// Add responsive media query styles for large and small promo background images
	const responsiveStyles = `
        <style>

		/* Large Promo Box Images */
		/* Sizes from 0px up: 420, 540, 740 */
		
		#${instanceId} .wc-spotlight-promo__box--large::before {
			background: linear-gradient(180deg, ${variables.ePromoLargeImageOverlayMobile} 0%, rgba(255, 255, 255, 0) 40%);
		}
		
		#${instanceId} .wc-spotlight-promo__box-image {
			background-image: url(${variables.ePromoLargeImage0px});
		}
		
		@media (min-width: 420px) {
			#${instanceId} .wc-spotlight-promo__box--large .wc-spotlight-promo__box-image {
				background-image: url(${variables.ePromoLargeImage420px});
			}
		}
		@media (min-width: 540px) {
			#${instanceId} .wc-spotlight-promo__box--large .wc-spotlight-promo__box-image {
				background-image: url(${variables.ePromoLargeImage540px});
			}
		}
		@media (min-width: 740px) {
			#${instanceId} .wc-spotlight-promo__box--large::before {
				background: linear-gradient(180deg, ${variables.ePromoLargeImageOverlayDesktop} 0%, rgba(255, 255, 255, 0) 40%);
			}
			
			#${instanceId} .wc-spotlight-promo__box--large .wc-spotlight-promo__box-image {
				background-image: url(${variables.ePromoLargeImage740px});
			}
		}
		
		/* Small Promo Box Images */
		/* Sizes from 0px up: 420, 540, 740, 840 */
		
		#${instanceId} .wc-spotlight-promo__box--small .wc-spotlight-promo__box-image {
			background-image: url(${variables.jPromoSmallImage0px});
		}
		@media (min-width: 420px) {
			#${instanceId} .wc-spotlight-promo__box--small .wc-spotlight-promo__box-image {
				background-image: url(${variables.jPromoSmallImage420px});
			}
		}
		@media (min-width: 540px) {
			#${instanceId} .wc-spotlight-promo__box--small .wc-spotlight-promo__box-image {
				background-image: url(${variables.jPromoSmallImage540px});
			}
		}
		@media (min-width: 740px) {
			#${instanceId} .wc-spotlight-promo__box--small .wc-spotlight-promo__box-image {
				background-image: url(${variables.jPromoSmallImage740px});
			}
		}
		@media (min-width: 840px) {
			#${instanceId} .wc-spotlight-promo__box--small .wc-spotlight-promo__box-image {
				background-image: url(${variables.jPromoSmallImage840px});
			}
		}
		
		</style>
    `;

	return `
        ${styleTag}
        ${responsiveStyles}
        <section id="${instanceId}" class="wc-spotlight-promo">
        	<div class="wc-spotlight-promo__container">
				<a href="${variables.cPromoLargeLinkURL}" class="wc-spotlight-promo__box wc-spotlight-promo__box--large">
					<div class="wc-spotlight-promo__box-image">
						<i></i>
					</div>
					<article>
						<h3>${variables.aPromoLargeHeading}</h3>
						<p>${variables.bPromoLargeCopy}</p>
					</article>
					<button>${variables.dPromoLargeLinkText}</button>
				</a>
				<a href="${variables.hPromoSmallLinkURL}" class="wc-spotlight-promo__box wc-spotlight-promo__box--small">
					<div class="wc-spotlight-promo__box-image">
						${
							variables.cPromoLargeLinkURL
								? `
							<div class="wc-spotlight-promo__box-image-overlay"><i></i></div>
						`
								: ''
						}
					</div>
					<article>
						<h3>${variables.fPromoSmallHeading}</h3>
						<p>${variables.gPromoSmallCopy}</p>
					</article>
					<button>${variables.iPromoSmallLinkText}</button>
				</a>
			</div>
		</section>
    `;
}
